import { useRouter } from "next/router";

export interface AppRedirectProps {
  path: string;
  includeReturnTo?: boolean;
}

export function AppRedirect(props: AppRedirectProps) {
  const router = useRouter();

  let path = props.path;

  if (props.includeReturnTo) {
    const returnTo = router.asPath;
    path = `${path}?returnTo=${encodeURIComponent(returnTo)}`;
  }

  router.push(path);

  return null;
}
